const IconIonic = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 128 128">
        <circle cx="64" cy="64" r="24.08" fill="#4e8ef7"/>
        <path fill="#4e8ef7" d="M113.14,23.14a8.27,8.27,0,0,0-13.7-6.25,59,59,0,1,0,11.67,11.67A8.24,8.24,0,0,0,113.14,23.14ZM64,121A57,57,0,1,1,98.1,18.36a8.27,8.27,0,0,0,11.53,11.53A57,57,0,0,1,64,121Z"/>
    </svg>
);

export default IconIonic;
